import { render, staticRenderFns } from "./SortingDropdown.vue?vue&type=template&id=506a667f&scoped=true"
import script from "./SortingDropdown.vue?vue&type=script&lang=js"
export * from "./SortingDropdown.vue?vue&type=script&lang=js"
import style0 from "./SortingDropdown.vue?vue&type=style&index=0&id=506a667f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a667f",
  null
  
)

export default component.exports